import { FeedbackBlock } from './feedback-block'

export default FeedbackBlock
